module.exports = __webpack_public_path__ + "4ed211b880d01a40b59c42a754d98a9f.pdf";